import { useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import Money from '../../../components/Common/Money/Money';
import ContentApp from '../../../components/ContentApp';
import Button from '../../../components/Common/Button/Button';
import axios from 'axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';
import { CircleSpinner } from 'react-spinners-kit';
import ContentBottom from '../../../components/ContentBottom';

const ConsumeSummary = () => {
  const history = useHistory();
  const [data, setData] = useState(null);
  const [selectedTip, setSelectedTip] = useState(null);
  const [tipAmount, setTipAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const tips = [18, 20, 22];
  const discount = 10;
  const [discountAmount, setDiscountAmount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://pos.wellet.travel/api/bill?table=011');
        setData(response.data);
        setDiscountAmount((response.data.subtotal * discount) / 100);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const setTips = (value) => {
    if (value === selectedTip) {
      setSelectedTip(null);
      setSelectedTip(0);
      setTipAmount(0);
      return;
    }

    setSelectedTip(value);
    setTipAmount((value / 100) * data.subtotal);
  };

  const onClickPay = () => {
    history.push({
      pathname: `/consume-pay`,
      state: { total: data.totalAmount, discount: discountAmount, tip: tipAmount },
    });
  };

  return (
    <>
      <Header pathName={`/`} title={'Cuenta #6554946'} />
      <ContentApp classes='pb-0'>
        {loading ? (
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        ) : (
          <>
            <div className='fw-semibold text-primary font-tiny mt-3'>Detalle de pedidos</div>
            <div className='px-2'>
              {data.items.map((item, i) => (
                <div className='row mt-3' key={i}>
                  <div className='col-auto my-auto'>{item.quantity}</div>
                  <div className='col'>
                    <div>{item.name}</div>
                    <div className='text-secondary'>
                      <Money value={item.unitPrice} />
                      &nbsp; c/u
                    </div>
                  </div>
                  <div className='col-auto my-auto'>
                    <Money value={item.totalPrice} />
                  </div>
                </div>
              ))}
            </div>

            <div className='fw-semibold text-primary font-tiny mb-3 mt-4'>
              Seleccione importe de la propina
            </div>
            <div className='row px-2'>
              {tips.map((tip, i) => (
                <div className='col px-1' key={i}>
                  <div
                    className={`button-filter text-center py-3 ${
                      selectedTip === tip ? 'active' : ''
                    }`}
                    onClick={() => setTips(tip)}
                  >
                    <div className='fw-semibold font-large'>{tip}%</div>
                    <div className='font-small'>
                      <Money value={(tip / 100) * data.subtotal} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              className='my-3'
              style={{ borderBottom: '1px solid #171717', position: 'relative' }}
            >
              <span
                style={{
                  position: 'absolute',
                  padding: '0 0.5rem',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -59%)',
                  zIndex: '1',
                  backgroundColor: '#000',
                }}
              >
                o
              </span>
            </div>
            <input
              type='number'
              placeholder='Ingrese otro importe de propina'
              style={{
                backgroundColor: '#131313',
                color: '#d9d9d9',
                borderRadius: '8px',
                lineHeight: '44px',
                width: '100%',
                border: 'none',
                padding: '0 1rem',
              }}
            />

            <div className='mt-5 fw-400'>
              <div className='text-lighter-gray'>
                <div className='row mt-1'>
                  <div className='col pr-0'>Importe:</div>
                  <div className='col-auto'>
                    <Money value={data.subtotal} />
                  </div>
                </div>

                <div className='row mt-1'>
                  <div className='col pr-0'>Descuento Advantage Network 10.00%:</div>
                  <div className='col-auto' style={{ color: '#7F0' }}>
                    -<Money value={discountAmount} />
                  </div>
                </div>
                <div className='mt-3'>
                  {tipAmount > 0 && (
                    <div className='row mt-1'>
                      <div className='col pr-0'>Propina:</div>
                      <div className='col-auto'>
                        <Money value={tipAmount} />
                      </div>
                    </div>
                  )}

                  <div className='row mt-1'>
                    <div className='col pr-0'>Impuestos:</div>
                    <div className='col-auto'>
                      <Money value={data.taxes} />
                    </div>
                  </div>

                  <div className='row mt-2 fw-semibold'>
                    <div className='col pr-0'>Total:</div>
                    <div className='col-auto'>
                      <Money value={data.totalAmount + tipAmount - discountAmount} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </ContentApp>
      {!loading && (
        <ContentBottom>
          <Button
            text={
              <>
                Pagar&nbsp;
                <Money value={data.totalAmount + tipAmount - discountAmount} />
              </>
            }
            size='large'
            className={`fw-semibold mt-3`}
            type='submit'
            onClick={() => onClickPay()}
            arrow
            color='#000'
            backgroundColor='var(--color-primary)'
            iconColor='#000'
          />
        </ContentBottom>
      )}
    </>
  );
};

export default ConsumeSummary;
